import React, { useEffect, useState } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { useSelector } from 'react-redux'

import PieTimerAnimation from 'components/common/animations/PieTimer'
import {
    gesturesMap,
    gestureTypes,
    gesturesKeys,
    gesturesData,
} from 'components/Tiles/Student/Gestures'
import {
    controlBarGestureEventEmitter,
    gestureKeys,
    emitGestureMsg,
    emitRevertGestureMsg,
} from 'helpers/events'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { _staticGestures } from 'store/selectors/Gestures'
import { keyToUse } from 'utils/hotKey'
import { logger } from 'utils/logger'
import { isDesktop } from 'utils/utils'

import {
    CheckBoxWrapper,
    CheckBox,
    CheckBoxLabel,
    Wrapper,
    PieTimerWrapper,
} from './StyledSwitchStyles'
import { Tooltip } from './TooltipStyles'

import StyledTooltip from '../../TooltipWrapper'

const StyledSwitch = props => {
    const staticGestures = useSelector(_staticGestures)

    const { userId } = useVideoContext()
    const [switchState, setSwitchState] = useState(false)
    const [showAnim, setShowAnim] = useState(false)

    React.useEffect(() => {
        let timeoutHandler
        const handleAcknowledgement = () => {
            const handleAcknowledgementToast = document.getElementById(
                'teacher-acknowledgement-toast'
            )
            if (handleAcknowledgementToast) {
                handleAcknowledgementToast.style.setProperty('display', 'flex')
                timeoutHandler = setTimeout(() => {
                    handleAcknowledgementToast.style.setProperty(
                        'display',
                        'none'
                    )
                }, [5000])
            }
        }

        controlBarGestureEventEmitter.addListener(
            gestureKeys.TEACHER_ACKNOWLEDGEMENT,
            handleAcknowledgement
        )

        return () => {
            if (timeoutHandler) {
                clearTimeout(timeoutHandler)
            }
            controlBarGestureEventEmitter.removeListener(
                gestureKeys.TEACHER_ACKNOWLEDGEMENT,
                handleAcknowledgement
            )
        }
    }, [])

    useEffect(() => {
        let gesture = Object.values(staticGestures).find(
            el => el.from_user === userId
        )
        let swicthValue = false
        if (
            gesture &&
            gesture.gesture_type &&
            gesture.gesture_type === gestureTypes.static &&
            gesture.gesture === gesturesMap.raiseHand
        ) {
            swicthValue = true
        }
        setSwitchState(swicthValue)
        logger.debug(
            `Hand raised gesture, with current state : ${
                swicthValue ? 'to be completed  ' : 'completed'
            }`
        )
    }, [staticGestures, userId])

    useEffect(() => {
        let timeoutHandler
        if (switchChange === null) return

        setShowAnim(() => true)
        timeoutHandler = setTimeout(() => setShowAnim(() => false), 2000)

        const gesture = gesturesData.find(
            item => item.gestureKey === gesturesKeys.raiseHand
        )
        const isGestureAutoReversible = gesture.autoRevert

        if (switchState) {
            emitGestureMsg({
                gestureKey: gesturesKeys.raiseHand,
                autoHide: isGestureAutoReversible,
                gestureType: switchState
                    ? gestureTypes.static
                    : gestureTypes.staticRevert,
            })
        } else {
            const storedGesture = Object.values(staticGestures).find(
                item =>
                    item.from_user === userId &&
                    item.gesture === gesture.gestureKey
            )

            if (storedGesture) {
                emitRevertGestureMsg({
                    gesturePK: storedGesture.gesture_pk,
                })
            }
        }

        return () => {
            if (timeoutHandler) {
                clearTimeout(timeoutHandler)
            }
        }
    }, [switchState])

    const switchChange = event => {
        const checked = event.currentTarget.checked
        setSwitchState(checked)
    }

    useHotkeys(
        `${keyToUse}+h`,
        e => {
            e.preventDefault()
            !showAnim && setSwitchState(state => !state)
        },
        [showAnim]
    )

    const orientation = isDesktop ? 'portrait' : 'landscape'

    return (
        <Wrapper orientation={orientation}>
            <Tooltip id="teacher-acknowledgement-toast">
                Teacher acknowledged
            </Tooltip>
            <StyledTooltip
                title={isDesktop ? 'raise hand' : ''}
                placement="left"
                arrow
                PopperProps={{ disablePortal: true }}
            >
                <CheckBoxWrapper orientation={orientation}>
                    <CheckBox
                        orientation={orientation}
                        reduceOpacity={showAnim}
                        checked={switchState}
                        onChange={switchChange}
                        id="checkbox"
                        type="checkbox"
                        disabled={props.disabled || showAnim}
                    />
                    <CheckBoxLabel
                        orientation={orientation}
                        htmlFor="checkbox"
                        reduceOpacity={showAnim}
                    >
                        {showAnim && (
                            <PieTimerWrapper orientation={orientation}>
                                <PieTimerAnimation />
                            </PieTimerWrapper>
                        )}
                    </CheckBoxLabel>
                </CheckBoxWrapper>
            </StyledTooltip>
        </Wrapper>
    )
}

export default StyledSwitch
